// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.MoThemeProvider = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styledComponents = require('../../styled-components');

var _Base = require('../../themes/Base.theme');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/* eslint-disable react/forbid-prop-types */
var MoThemeProvider = function MoThemeProvider(props) {
  var children = props.children,
    theme = props.theme;
  var combinedTheme = Object.assign(_Base.BaseTheme, theme);
  return _react.default.createElement(
    _styledComponents.ThemeProvider,
    {
      theme: combinedTheme
    },
    children
  );
};

exports.MoThemeProvider = MoThemeProvider;
MoThemeProvider.defaultProps = {
  children: null,
  theme: _Base.BaseTheme
};
MoThemeProvider.propTypes = {
  children: _propTypes.default.oneOfType([
    _propTypes.default.arrayOf(_propTypes.default.node),
    _propTypes.default.node,
    _propTypes.default.string,
    _propTypes.default.object
  ]),
  theme: _propTypes.default.any
};
